import React from 'react';
// Import images
import img1 from '../../assets/images/sploshing/mistress-md-professional-dominatrix-sploshing-small.png';
import img3 from '../../assets/images/sploshing/mistress-md-professional-dominatrix-sploshing-outside-pink.jpg';
import img2 from '../../assets/images/sploshing/mistress-md-professional-dominatrix-sploshing-outside-plate.jpg';
import img4 from '../../assets/images/sploshing/mistress-md-professional-dominatrix-sploshing-outside-squirt-gun.jpg';
// Components
import MainContainerContent from '../general/MainContainerContent';
import GeneralPriceTable from '../general/GeneralPriceTable';
// Data
import { sploshingRatesArray } from '../../utils/data/PriceData';

function SploshingPageMainContainer() {
  return (
    <main role='main' className='grid pt-6 pb-12'>
      <MainContainerContent
        title='A Feast of Submission'
        subtitle='Indulgence, Humiliation, and Total Control'
        paraOne='Enter my world of decadent destruction, where control meets chaos, and you become my personal canvas. With every dollop, drizzle, and splash, I transform you into a masterpiece of mess—a plaything to be coated, covered, and consumed by my amusement.'
        paraTwo={`Feel the weight of luscious desserts, the slow trickle of syrup down your skin, the overwhelming sensation of being completely drenched in my decadent desires. There’s no escape, no control—only the pleasure of absolute surrender. Book your messy fate now and let me ruin you in the most delicious way possible.`}
        images={[img1, img2, img3, img4]}
      />

      <GeneralPriceTable
        title='Sploshing Prices'
        rates={sploshingRatesArray}
        depositMessage='A £60 deposit (non-negotiable & non-refundable) is required to secure a booking.'
        extraMessage='Extras apply for sessions involving mess, topless, or nudity.'
      />
    </main>
  );
}

export default SploshingPageMainContainer;
